import Alert from '@mui/material/Alert';
import HomeContainer from '../containers/HomeContainer';

function HomePage() {
  return (
    <div className="content-surface">
      <Alert severity="info">If you plan to setup multiple resources within an Azure Resource Group (for example a WebApp with a SQL database)
        <br />
        Please contact us at
        <br /><br />
        <a href='mailto: YOL-IT-IS-CA@wacker.com'>YOL-IT-IS-CA@wacker.com</a>
        <br /><br />
        to create a custom project.</Alert>
      <HomeContainer />
    </div>
  );
}

export default HomePage;